import { WebsiteBuilderDividerWeight, websiteBuilderGenerateDefaultDivider } from "../../element/websiteBuilderDivider";
import { websiteBuilderGenerateDefaultParagraph } from "../../element/websiteBuilderParagraph";
import { IWebsiteBuilderMediaItem } from "redux/reducers/models/websiteBuilder";
import { IWebsiteBuilderContent, websiteBuilderGenerateDefaultContent } from "../websiteBuilderContent";
import { websiteBuilderGenerateTemplateImage } from "./websiteBuilderResolveTemplateMedia";

export function websiteBuilderGalleryTemplate(media: IWebsiteBuilderMediaItem[]): IWebsiteBuilderContent {
  const section = websiteBuilderGenerateDefaultContent();
  const subHeading = websiteBuilderGenerateDefaultParagraph();
  const subHeadingDivider = websiteBuilderGenerateDefaultDivider();
  const firstImage = websiteBuilderGenerateTemplateImage(media, "edwin-compton");
  const secondImage = websiteBuilderGenerateTemplateImage(media, "welcome");
  const thirdImage = websiteBuilderGenerateTemplateImage(media, "golf-course-with-green-trees");
  const fourthImage = websiteBuilderGenerateTemplateImage(media, "golf-course-island");

  section.section.layout.desktop.height = 730;
  section.section.layout.tablet.height = 530;
  section.section.layout.mobile.height = 960;

  subHeading.element.layout.desktop.position = { x: 80, y: 80 };
  subHeading.element.layout.tablet.position = { x: 32, y: 40 };
  subHeading.element.layout.mobile.position = { x: 25, y: 40 };
  subHeading.element.layout.desktop.dimensions = { width: 115, height: 25 };
  subHeading.element.layout.tablet.dimensions = { width: 115, height: 25 };
  subHeading.element.layout.mobile.dimensions = { width: 115, height: 25 };
  subHeading.element.settings.content = {
    type: "doc",
    attrs: {
      responsiveFontSize: {
        desktop: "12px",
        tablet: "12px",
        mobile: "12px",
      },
    },
    content: [{
      type: "paragraph",
      content: [{
        type: "text",
        text: "COURSE GALLERY", // TODO: Translation
        marks: [{
          type: "textStyle",
          attrs: {
            color: "#285E1A",
          },
        }],
      }],
    }],
  };

  subHeadingDivider.element.layout.desktop.position = { x: 200, y: 89 };
  subHeadingDivider.element.layout.tablet.position = { x: 152, y: 49 };
  subHeadingDivider.element.layout.mobile.position = { x: 145, y: 49 };
  subHeadingDivider.element.layout.desktop.dimensions = { width: 125, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.tablet.dimensions = { width: 100, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.layout.mobile.dimensions = { width: 90, height: WebsiteBuilderDividerWeight.EXTRA_THICK };
  subHeadingDivider.element.settings.weight = WebsiteBuilderDividerWeight.THIN;
  subHeadingDivider.element.settings.color = "#285E1A";

  firstImage.element.layout.desktop.position = { x: 80, y: 115 };
  firstImage.element.layout.tablet.position = { x: 32, y: 75 };
  firstImage.element.layout.mobile.position = { x: 25, y: 75 };
  firstImage.element.layout.desktop.dimensions = { width: 412, height: 535 };
  firstImage.element.layout.tablet.dimensions = { width: 346, height: 415 };
  firstImage.element.layout.mobile.dimensions = { width: 270, height: 200 };
  firstImage.element.settings.alt = "Golf course bunker"; // TODO: Translation
  firstImage.element.settings.borderRadius = 12;

  secondImage.element.layout.desktop.position = { x: 508, y: 115 };
  secondImage.element.layout.tablet.position = { x: 390, y: 75 };
  secondImage.element.layout.mobile.position = { x: 25, y: 290 };
  secondImage.element.layout.desktop.dimensions = { width: 198, height: 260 };
  secondImage.element.layout.tablet.dimensions = { width: 167, height: 201 };
  secondImage.element.layout.mobile.dimensions = { width: 270, height: 200 };
  secondImage.element.settings.alt = "Aerial view of a golf green"; // TODO: Translation
  secondImage.element.settings.borderRadius = 12;

  thirdImage.element.layout.desktop.position = { x: 722, y: 115 };
  thirdImage.element.layout.tablet.position = { x: 569, y: 75 };
  thirdImage.element.layout.mobile.position = { x: 25, y: 505 };
  thirdImage.element.layout.desktop.dimensions = { width: 198, height: 260 };
  thirdImage.element.layout.tablet.dimensions = { width: 167, height: 201 };
  thirdImage.element.layout.mobile.dimensions = { width: 270, height: 200 };
  thirdImage.element.settings.alt = "Golf course putting green"; // TODO: Translation
  thirdImage.element.settings.borderRadius = 12;

  fourthImage.element.layout.desktop.position = { x: 508, y: 390 };
  fourthImage.element.layout.tablet.position = { x: 390, y: 288 };
  fourthImage.element.layout.mobile.position = { x: 25, y: 720 };
  fourthImage.element.layout.desktop.dimensions = { width: 412, height: 260 };
  fourthImage.element.layout.tablet.dimensions = { width: 346, height: 202 };
  fourthImage.element.layout.mobile.dimensions = { width: 270, height: 200 };
  fourthImage.element.settings.alt = "Aerial view of an island green"; // TODO: Translation
  fourthImage.element.settings.borderRadius = 12;

  section.children = [subHeading, subHeadingDivider, firstImage, secondImage, thirdImage, fourthImage];

  return section;
}
